import React, { FC } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import stringUtils from '../../utils/string';
import classes from './styles/index.module.scss';
import { PreviewFieldProps } from './PreviewField';
import '../../../UnreachableJs/libs/tinymce/tinyMceHtmlView.css';

type PickedKeys = 'value' | 'placeholder';
type PreviewFieldHTMLProps = Pick<PreviewFieldProps, PickedKeys> & {
	valueClasses?: string;
	defaultPlaceholder?: string;
	dataTestId?: string;
};

export const PreviewFieldHTML: FC<React.PropsWithChildren<PreviewFieldHTMLProps>> = ({
	valueClasses,
	value,
	placeholder,
	defaultPlaceholder,
	dataTestId,
}) => {
	const hasValue = !stringUtils.isNullOrEmpty(value);
	const html = hasValue ? (value as string) : placeholder || defaultPlaceholder;

	const componentClasses = classNames(classes.previewFieldHTML, 'tinyMceBody', valueClasses);

	return (
		<div
			className={componentClasses}
			dangerouslySetInnerHTML={{ __html: html! }}
			data-testid={dataTestId}
		/>
	);
};

PreviewFieldHTML.propTypes = {
	dataTestId: PropTypes.string,
};

export default PreviewFieldHTML;
